import React, { Component } from 'react';
// import logo from './logo.svg';
import { Link } from 'react-router';
import logo from './Emojione_1F4A9.svg';
import './App.css';
import Helmet from "react-helmet";

import database from './database';
import Asin from './Asin';



class App extends Component {
  render() {
    const meta = {
      meta: [
        { property: 'twitter:card', content: 'summary_large_image' } ,
        { property: 'og:title', content: 'best worst amzn reviews' } ,
        { property: 'og:url', content: `http://www.amzn.dance`} ,
        { property: 'og:description', content: 'the worst products, reviewed' } ,
        { property: 'og:image', content: 'https://s-media-cache-ak0.pinimg.com/236x/4b/25/a4/4b25a4c9229955532af0e1000be91082.jpg' }
      ]
    };

    const items = database.map( (item, i) => <Asin key={i} {...item} />);

    let children = this.props.children || <div className="items">{items}</div>;

    return (
      <div className="App">
        <Helmet {...meta} />
        <div className="App-header">
          <Link to="/"><img src={logo} className="App-logo" alt="logo" /></Link>
          <h2><Link to="/">low-rated things from amazon</Link></h2>
        </div>
        {children}
      </div>
    );
  }
}

export default App;



/** WEBPACK FOOTER **
 ** ./src/App.js
 **/